import React from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import LandingV1 from './LandingPage';
import LandingV2 from './../LandingV2';

export const Landing = ({ asset, translations }) => {
  const landingConfig = useSelector(
    selectMetadataKeyByRegion('landing_telmex_config'),
  );

  return landingConfig?.enable ? (
    <LandingV2 />
  ) : (
    <LandingV1 asset={asset} translations={translations} />
  );
};

export default Landing;
